import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './index.css'
import BEMHelper from 'react-bem-helper'
const classes = new BEMHelper('preview')

export default class Preview extends Component {
  static propTypes = {
    slides: PropTypes.array.isRequired,
    type: PropTypes.string,
  }

  static defaultProps = {
    type: 'iphone',
  }

  constructor () {
    super()

    this.state = {
      slide: 0,
      slideWidth: 205,
    }
  }

  componentDidMount () {
    this.slideWidth()

    window.addEventListener('resize', this.slideWidth)
  }

  setSlide = index => {
    const { slide } = this.state

    this.setState({
      slide: index,
      duration: (Math.abs(slide - index) + 2) * 120,
    })
  }

  slideModifier = index => {
    const { slide } = this.state
    const { type } = this.props

    return [
      type,
      slide > index && 'before',
      slide < index && 'after',
      `distance-${Math.min(4, Math.abs(slide - index))}`,
    ]
  }

  slideWidth = () => {
    const spacing = 48

    this.setState({
      slideWidth: this.activeEl.offsetWidth + spacing,
    })
  }

  render () {
    const { slide, duration, slideWidth } = this.state
    const { slides, type } = this.props

    const contentStyle = {
      transform: `translateX(-${slide * slideWidth}px)`,
      transitionDuration: `${duration}ms`,
    }

    return (
      <div {...classes('', type)}>
        {type === 'iphone' && <div {...classes('overlay', 'iphone')} />}
        {type === 'mac' && <div {...classes('overlay', 'mac')} />}

        <div {...classes('wrapper', type)}>
          <div {...classes('content')} ref="content" style={contentStyle}>
            {slides.map(({ src, caption }, index) => (
              <figure
                {...classes('item', this.slideModifier(index))}
                key={index}
                role="button"
                ref={el => {
                  if (index === slide) {
                    this.activeEl = el
                  }
                }}
              >
                <img
                  {...classes('image')}
                  src={src}
                  alt={caption}
                  onClick={() => this.setSlide(index)}
                />
              </figure>
            ))}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Preview/index.js